import { AdvancedMarker, useAdvancedMarkerRef, useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";
import MapPropertiesService from "../services/MapPropertiesService";
import { MapCircle } from "./MapCircle";

interface MapSelectedPositionProps {
    position: google.maps.LatLng | null,
    positionType: string,
    selectedPosition: google.maps.LatLng | null
    setSelectedPosition: (e: google.maps.LatLng) => void,
    canClick: boolean
}

export const MapSelectedPosition = ({
    position,
    positionType,
    selectedPosition,
    setSelectedPosition,
    canClick = false
}: MapSelectedPositionProps) => {

    const map = useMap();
    const mapClickTypes = MapPropertiesService.clickTypes;

    useEffect(() => {

        if (!map || !position) return;

        if (!selectedPosition) {
            setSelectedPosition(position);
            map.setCenter(position);
        } else if (position.lat !== selectedPosition.lat &&
            position.lng !== selectedPosition.lng) {
            setSelectedPosition(position)
            map.setCenter(position);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, position, selectedPosition]);

    return (
        canClick &&
        (() => {
            switch (positionType) {
                case mapClickTypes.Marker:
                    return (
                        <MapPositionMarker
                            position={selectedPosition} />
                    );
                case mapClickTypes.Circle:
                    return (
                        <MapSelectedPositionCircle
                            position={selectedPosition} />
                    );
                default:
                    return null;
            }
        })()
    )
}

interface MapPositionMarkerProps {
    position: google.maps.LatLng | null,

}
const MapPositionMarker = ({ position }: MapPositionMarkerProps) => {

    const [markerRef] = useAdvancedMarkerRef();

    return (
        <AdvancedMarker
            ref={markerRef}
            position={position}
        />
    )
}

interface MapSelectedPositionCircleProps {
    position: google.maps.LatLng | null,

}
const MapSelectedPositionCircle = ({
    position }: MapSelectedPositionCircleProps) => {
    return (
        <MapCircle
            center={position}
            strokeOpacity={0.8}
            strokeWeight={2}
            strokeColor={"#1e7145"}
            fillColor={"#90EE90"}
            fillOpacity={0.4}
            radius={800}
        />
    )
}
